import { IdentifierCasing } from "@/apollo/types";

/**
 * Mirrors `applyIdentifierCasing` in the backend
 * (`libs/core/src/data-warehouse/identifier-casing.ts`). An unset casing leaves the name as typed,
 * which is what every account created before the setting existed relies on. Keep the two in sync.
 */
export function applyIdentifierCasing(
  name: string,
  casing: IdentifierCasing | null | undefined,
): string {
  return casing === IdentifierCasing.Uppercase ? name.toUpperCase() : name;
}

export function identifierCasingLabel(casing: IdentifierCasing): string {
  return casing === IdentifierCasing.Uppercase ? "Upper case" : casing;
}

export const IDENTIFIER_CASING_LABEL =
  "Create tables and columns in upper case";

export const IDENTIFIER_CASING_DESCRIPTION =
  "Snowflake resolves unquoted names to upper case, so upper-case identifiers can be queried " +
  "without quoting.";

/**
 * Only worth saying where syncs can already exist. At warehouse setup there are none, so it would
 * describe a situation the reader cannot be in.
 */
export const IDENTIFIER_CASING_EXISTING_SYNCS_NOTE =
  "Applies to syncs created from now on — existing tables keep the casing they were created with.";
